// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-block[data-v-b48fe20e]{max-width:884px}@media screen and (max-width:768px){.ribbon-text[data-v-b48fe20e] p{font-size:20px;line-height:28px}}@media screen and (max-width:480px){.ribbon-text[data-v-b48fe20e] p{font-size:18px;line-height:24px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
